import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCurrentUser(options = {}) {
	return _apiRequestWrap(
		ModulesMap.USER,
		ModulesConfigMap[ModulesMap.USER].GET_CURRENT_USER,
		options
	)
}

function _fetchAvailableCompanies(options = {}) {
	return _apiRequestWrap(
		ModulesMap.USER,
		ModulesConfigMap[ModulesMap.USER].GET_AVAILABLE_COMPANIES,
		options
	)
}

function _putUser(options = {}) {
	return _apiRequestWrap(ModulesMap.USER, ModulesConfigMap[ModulesMap.USER].PUT_USER, options)
}

function _patchUser(options = {}) {
	return _apiRequestWrap(ModulesMap.USER, ModulesConfigMap[ModulesMap.USER].PATCH_USER, options)
}

function _setPassword(options = {}) {
	return _apiRequestWrap(ModulesMap.USER, ModulesConfigMap[ModulesMap.USER].SET_PASSWORD, options)
}

export default {
	getCurrentUser: _getCurrentUser,
	[ModulesConfigMap[ModulesMap.USER].GET_AVAILABLE_COMPANIES]: _fetchAvailableCompanies,
	[ModulesConfigMap[ModulesMap.USER].PUT_USER]: _putUser,
	[ModulesConfigMap[ModulesMap.USER].PATCH_USER]: _patchUser,
	[ModulesConfigMap[ModulesMap.USER].SET_PASSWORD]: _setPassword,
}
